import { render, staticRenderFns } from "./Designated.vue?vue&type=template&id=61a2bae8&scoped=true"
import script from "./Designated.vue?vue&type=script&lang=js"
export * from "./Designated.vue?vue&type=script&lang=js"
import style0 from "./Designated.vue?vue&type=style&index=0&id=61a2bae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2bae8",
  null
  
)

export default component.exports